import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(portal)/layout.tsx");
